import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const self = this

    setTimeout(function() {
      self.element.remove()
    }, 1500)
  }
}
